const serverUrl = "https://proxy.mindset-res.com";
export default serverUrl;
